<div
  class="customFieldGroupsImport"
  [reactComponent]="ImportCustomFieldGroups"
  [props]="reactProps"
></div>
